<template>
	<div id="home-page">

		<landing-banners key="header-banner"/>

		<section class="services-section" id="h-paquetes">
			<div class="container oversized-container">
				<div class="content">

					<ui-tabs v-model="servTab" class="mt-3" :options="servOptions" disable-button-mode auto-select-first/>

					<template v-if="servTab == 'movi'">
						<movil-component />
						<contrata-ya-landing key="movi" disable-redirect-on-mount hide-progress-bar/>
					</template>

					<template v-else-if="servTab == 'soloDatos' && allowSoloDatos">
						<mifi-component />
						<contrata-ya-landing only-mifi key="mifi" disable-redirect-on-mount hide-progress-bar/>
					</template>

				</div>
			</div>
		</section>

		<landing-banners key="footer-banner" footer/>

		<div class="products-results-fix-margins">
			<products-results-page just-one-row title="Conoce nuestros últimos equipos" />
			<pages-results-page  just-one-row  />
		</div>

		<!-- <LandingComunicados /> -->

	</div>
</template>

<script>
import _ from 'lodash'
import MovilComponent from './services/MovilComponent';
import MifiComponent from './services/MifiComponent';
import CasaComponent from './services/CasaComponent';
import LandingBanners from '../daniel/landing/landing-banners'
// import LandingComunicados from '../daniel/landing/landing-comunicados'
import contrataYaLanding from '../daniel/contrata-ya/landing.vue'
import {mapGetters} from 'vuex'
import ApiImgPristine from '../daniel/api-img-pristine.vue';
import productsResultsPage from '@/js/components/page/products/index.vue'
import pagesResultsPage from '@/js/components/page/pages/index.vue'

const servOptions = [
	{key: "movi", label: "Telefonía"},
	{key: "soloDatos", label: "Solo datos"},
]

export default {
	name: 'HomeIndex',

	props:{
		servOptions: {
			type: Array,
			default: () => servOptions
		},
		allowSoloDatos: {
			type: Boolean,
			default: true
		}
	},

	components: {
		productsResultsPage,
		pagesResultsPage,
		MovilComponent, 
		MifiComponent, 
		CasaComponent, 
		LandingBanners, 
		// LandingComunicados, 
		ApiImgPristine, 
		contrataYaLanding
	},

	data(){
		return{
		
			servTab: 'movi',

			banners: [
				{ imageUrl: 'public/images/pages/home/banner-1.jpg', device: 'pc' },
				{ imageUrl: 'public/images/pages/home/banner-2.jpg', device: 'pc' },
				{ imageUrl: 'public/images/pages/home/banner-1.jpg', device: 'movil' },
				{ imageUrl: 'public/images/pages/home/banner-2.jpg', device: 'movil' },
			],

			// products: [
				// { id: 5, image_url: 'public/images/pages/products/product-1.jpg', nombre: 'Celular Samsung A12 5ta generación' },
				// { id: 5, image_url: 'public/images/pages/products/product-2.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-3.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-4.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-3.jpg', nombre: 'Celular Samsung A12 5ta generación' },
				// { id: 5, image_url: 'public/images/pages/products/product-1.jpg', nombre: 'Celular Samsung A12 5ta generación' },
			// ],

			/* == Carousel options == */

			prodsOptions: {
				slidesPerView: 5,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},

				breakpoints: {
					1400: {
						slidesPerView: 5
					},
					1100: {
						slidesPerView: 4
					},
					992: {
						slidesPerView: 3
					},
					400: {
						slidesPerView: 2
					},
					1: {
						slidesPerView: 1
					},
				}
			},

		}
	},
	computed: {
		...mapGetters(['catalogosGetProductos']),
		products(){
			return _.filter(this.catalogosGetProductos, item => {
				console.debug(item)
				return true
			})
		}
	}
}
</script>

<style scoped>
	.products-results-fix-margins {
		margin: 5em 0; 
	}
</style>